import SwitchRow from "./SwitchRow"

export default SwitchRow
